if (!customElements.get('project-media-gallery')) {
  customElements.define(
    'project-media-gallery',
    class ProjectMediaGallery extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.enableSliderMobile = this.dataset.enableSliderMobile === 'true';
        if (!this.enableSliderMobile) {
          return;
        }

        this.selectors = {
          slider: '.project__media-viewer',
          sliderWrapper: '.project__media-wrapper',
          paginationEl: '.swiper-pagination',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        };

        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
          swiperControlsVisible: 'slider-controls--grouped-mobile',
        };

        this.slider = this.querySelector(this.selectors.slider);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        this.sliderInstance = false;

        this.init();
        document.addEventListener('matchMobile', () => {
          this.init();
        });
        document.addEventListener('unmatchMobile', () => {
          this.init();
        });
      }

      init() {
        if (AfcTheme.config.mqlMobile) {
          this.initSlider();
        } else {
          this.destroySlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const sliderOptions = {
          slidesPerView: 1,
          spaceBetween: 8,
          navigation: {
            nextEl: this.querySelector(this.selectors.nextEl),
            prevEl: this.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.querySelector(this.selectors.paginationEl),
            clickable: true,
          },
          loop: true,
          threshold: 2,
          autoHeight: true,
        };

        this.classList.add(this.classes.swiperControlsVisible);
        this.slider.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.AfcTheme.Carousel(this.slider, sliderOptions);
        this.sliderInstance.init();

        const focusableElements = AfcTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });
      }

      destroySlider() {
        this.classList.remove(this.classes.swiperControlsVisible);
        this.slider.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);

        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }
    }
  );
}
